'use client'

import { useActionState } from 'react'
import Link from 'next/link'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { login } from '@/app/actions/auth'

export default function LoginPage() {
  const [state, formAction, pending] = useActionState(login, null)

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl text-center">ログイン</CardTitle>
        </CardHeader>
        <CardContent>
          <form action={formAction} className="space-y-4">
            {state?.error && (
              <div className="p-3 rounded bg-red-50 border border-red-200 text-red-700 text-sm">
                {state.error}
                {state.code === 'EMAIL_NOT_VERIFIED' && (
                  <div className="mt-2">
                    <Link
                      href={`/resend-verify?email=${encodeURIComponent(state.email)}`}
                      className="underline font-medium"
                    >
                      確認メールを再送する
                    </Link>
                  </div>
                )}
              </div>
            )}
            <div className="space-y-2">
              <Label htmlFor="email">メールアドレス</Label>
              <Input id="email" name="email" type="email" required placeholder="shop@example.com" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">パスワード</Label>
              <Input id="password" name="password" type="password" required />
            </div>
            <Button type="submit" className="w-full" disabled={pending}>
              {pending ? 'ログイン中...' : 'ログイン'}
            </Button>
            <div className="text-right">
              <Link href="/forgot-password" className="text-sm text-gray-500 hover:underline">
                パスワードをお忘れの方
              </Link>
            </div>
          </form>
          <p className="mt-4 text-center text-sm text-gray-600">
            アカウントをお持ちでない方は{' '}
            <Link href="/register" className="text-blue-600 hover:underline">
              新規登録
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
